﻿import $ from 'jquery';
import ko from 'knockout';
import { IBinder, IBehaviorBinding, ICellBinding } from "./ibinder"

  export class EnterKeyBinder implements IBinder {
    public getElements(row: JQuery): JQuery {
      if (row.parents("tbody").length == 0)
        return $();
      return row.find(EnterKeyBinder.inputSelector);
    }

    public getBinding(element: JQuery): IBehaviorBinding {
      return {
        bindingName: "event",
        bindTo: "{keyup : $parent.enterKey}",
        createEmptyValue: () => null,
        behavior: {
          name: "enterKey",
          build: data => (item, event) => {
            var cell = $(event.currentTarget).parents(".et-field");
            var row = cell.parents("tr");
            var rowIndex = row.parent().children("tr").index(row);

            if (event.keyCode == EnterKeyBinder.enterKey) {
              if (!event.shiftKey)
                EnterKeyBinder.moveTo(cell, rowIndex + 1);
              else if (rowIndex != 0)
                EnterKeyBinder.moveTo(cell, rowIndex - 1);
            }
            return true;
          }
        }
      }
    }


    private static highlightSelection(element: JQuery) {
      var e: any = element[0];
      if (e != undefined && "selectionStart" in e) {
        try {
          let val = element.val() as string;
          e.selectionStart = 0;
          e.selectionEnd = val.length;
        }
        catch (er) { }
      }
    }

    private static moveTo(currentCell: JQuery, rowIndex: number) {
      var cell = $(event.currentTarget).parents(".et-field");
      var row = cell.parents("tr");
      var tbody = row.parents("tbody");
      var columnIndex = row.children("td").index(cell);
      var element = tbody.find("tr").eq(rowIndex).find("td").eq(columnIndex).find(EnterKeyBinder.inputSelector);
      element.focus();
      EnterKeyBinder.highlightSelection(element);
    }

    private static inputSelector = "input:not(\"[type='hidden']\")";
    private static enterKey = 13;
  }
